module.exports = __webpack_public_path__ + "static/media/Soldoutbadge.svg";